import { Trash2, Wrench } from 'lucide-react';

import { Button } from 'components/ui/button';

type AgentConfigToolCardProps = {
  tool: { id: string; name: string; description?: string };
  onRemove: (toolId: string) => void;
  disabled?: boolean;
};

export function AgentConfigToolCard({ tool, onRemove, disabled = false }: AgentConfigToolCardProps) {
  return (
    <div
      className={`flex items-center justify-between rounded-lg border p-4 ${disabled ? 'opacity-50' : ''}`}
    >
      <div className="flex min-w-0 flex-1 items-center gap-3">
        <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded bg-primary/10">
          <Wrench className="h-5 w-5" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="truncate font-medium text-foreground">{tool.name}</div>
          <div className="line-clamp-1 text-sm text-muted-foreground">
            {tool.description || 'No description'}
          </div>
        </div>
      </div>

      <Button
        type="button"
        variant="outline"
        onClick={() => onRemove(tool.id)}
        disabled={disabled}
        className="text-muted-foreground hover:text-destructive disabled:cursor-not-allowed disabled:opacity-50"
      >
        <Trash2 className="h-4 w-4" />
      </Button>
    </div>
  );
}
